var generateCartUrl;

generateCartUrl = function(optionuuid, dealuuid) {
  return "/cart/add/" + optionuuid + "?deal_id=" + dealuuid;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.Cart == null) {
    window.Cart = {};
  }
  if (Cart.Helpers == null) {
    Cart.Helpers = {};
  }
  Cart.Helpers.generateCartUrl = generateCartUrl;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    generateCartUrl: generateCartUrl
  };
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9jYXJ0L2NvbW1vbi9oZWxwZXJzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvY2FydC9jb21tb24vaGVscGVycy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxlQUFBLEdBQWtCLFNBQUMsVUFBRCxFQUFhLFFBQWI7QUFDaEIsU0FBTyxZQUFBLEdBQWEsVUFBYixHQUF3QixXQUF4QixHQUFtQztBQUQxQjs7QUFHbEIsSUFBRyxnREFBSDs7SUFDRSxNQUFNLENBQUMsT0FBUzs7O0lBQ2hCLElBQUksQ0FBQyxVQUFXOztFQUNoQixJQUFJLENBQUMsT0FBTyxDQUFDLGVBQWIsR0FBK0IsZ0JBSGpDOzs7QUFLQSxJQUFHLGdEQUFIO0VBQ0UsTUFBTSxDQUFDLE9BQVAsR0FBaUI7SUFBQyxpQkFBQSxlQUFEO0lBRG5CIn0=
